import React from 'react';
import shippingBoxTinyNudgeIcon from '@reverbdotcom/cadence/images/nudge/shipping-box--tiny.svg';
import gemTinyNudgeIcon from '@reverbdotcom/cadence/images/nudge/gem--tiny.svg';
import fastTruckTinyNudgeIcon from '@reverbdotcom/cadence/images/nudge/fast-truck-tiny.svg';
import locationPinTinyNudgeIcon from '@reverbdotcom/cadence/images/nudge/location-pin--tiny.svg';
import cartTinyNudgeIcon from '@reverbdotcom/cadence/images/nudge/cart--tiny.svg';
import sparklesIcon from '@reverbdotcom/cadence/images/nudge/sparkles.svg';
import { I18N } from './translate';
import { experimentInt } from '../user_context_helpers';
import experiments from '../experiments';
import { useUser } from '../user_hooks';
import { IUser } from './user_context_provider';
interface IProps {
  displayMultiple?: boolean;
  freeExpeditedShipping?: boolean;
  freeShipping?: boolean;
  greatValue?: boolean;
  inOtherCartsCount: number;
  localPickupOnly?: boolean;
  localPickupAvailable?: boolean;
  returnPolicyDays: number;
  newListing?: boolean;
}

ListingCardNudge.defaultProps = {
  inOtherCartsCount: 0,
  returnPolicyDays: 0,
};

function getNudgesToDisplay(props: IProps, user: Partial<IUser>) {
  const applicableNudges = [];
  const newListingSignalMarketplaceExpGroup = experimentInt(user, experiments.RECENTLY_LISTED_SIGNAL_MARKETPLACE_V2);

  if (props.freeExpeditedShipping) { applicableNudges.push({ i18key: 'freeExpeditedShipping', icon: fastTruckTinyNudgeIcon }); }
  if (props.freeShipping && !props.freeExpeditedShipping) { applicableNudges.push({ i18key: 'freeShipping', icon: fastTruckTinyNudgeIcon }); }
  if (props.returnPolicyDays >= 14) { applicableNudges.push({ i18key: 'returnPolicy', icon: shippingBoxTinyNudgeIcon }); }
  if (props.inOtherCartsCount > 0) { applicableNudges.push({ i18key: 'inOtherCarts', icon: cartTinyNudgeIcon }); }
  if (props.localPickupOnly) { applicableNudges.push({ i18key: 'localPickup', icon: locationPinTinyNudgeIcon }); }
  if (props.localPickupAvailable) { applicableNudges.push({ i18key: 'localPickupAvailable', icon: locationPinTinyNudgeIcon }); }
  if (props.greatValue) { applicableNudges.push({ i18key: 'greatValue', icon: gemTinyNudgeIcon }); }
  if (props.newListing && (newListingSignalMarketplaceExpGroup === 1 || newListingSignalMarketplaceExpGroup === 2)) { applicableNudges.push({ i18key: 'newListing', icon: sparklesIcon }); }
  
  return applicableNudges.slice(0, getNudgeDisplayCount(props.displayMultiple, newListingSignalMarketplaceExpGroup));
}

function getNudgeDisplayCount(displayMultiple: boolean, newListingSignalMarketplaceExpGroup: number) {
  const defaultAmount = displayMultiple ? 2 : 1;

  if (displayMultiple && newListingSignalMarketplaceExpGroup === 1) {
    return defaultAmount + 1;
  }

  return defaultAmount;
}

function getDisplayTextArgs(i18key, props) {
  if (i18key === 'returnPolicy') return ({ returnPolicyDays: (props.returnPolicyDays || 0) });
  if (i18key === 'inOtherCarts') return ({ count: (props.inOtherCartsCount) });
  return {};
}

export default function ListingCardNudge(props: IProps) {
  const user = useUser();
  const nudgesToDisplay = getNudgesToDisplay(props, user);
  if (!nudgesToDisplay.length) return null;

  return (
    <>
      {nudgesToDisplay.map(displayHash => {
        return (
          <div className="listing-card-nudge" key={displayHash.i18key}>
            <img src={displayHash.icon} alt="" />
            <I18N
              text={`commons.listingCardNudge.${displayHash.i18key}`}
              args={getDisplayTextArgs(displayHash.i18key, props)}
            />
          </div>
        );
      })}
    </>
  );
}
